import http from '../services/http.service';

export const isUnique = (value, url) => {
    return http.get(`${url}/${value}`).then(result => {
        return {
            valid: result.data,
            data: {
                // TODO: Not working... -> message: 'Не е уникално'
            }
        }
    });
}
